import { SquirrelIcon } from "lucide-react";

import { useRouterBack } from "@/shared-web.ui/hook.use-router-back";
import { Button } from "@/shared-web.ui/ui.button";
import { Flex } from "@/shared-web.ui/ui.flex";
import { ScrollArea } from "@/shared-web.ui/ui.scroll-area";
import { Text } from "@/shared-web.ui/ui.text";

import { useCartContext } from "./cart.context";
import { ShopCart } from "./shop-cart.ui";

interface CartBodyProps {
  className?: string;
}
const CartBody = (props: CartBodyProps) => {
  const { className } = props;
  const { cartState: {
    cartData: {
      itemList,
      shopList,
    },
  } } = useCartContext();

  const { routerBack } = useRouterBack();

  if (itemList.length === 0) {
    return (
      <div className={`
        flex size-full flex-col items-center justify-center
        gap-4
      `}
      >
        <SquirrelIcon
          strokeWidth="1"
          className="size-32 text-accent-6"
        />
        <Text semanticColor="accent">
          Your cart is empty
        </Text>
        <Button
          type="button"
          onClick={routerBack}
        >
          Continue Shopping
        </Button>
      </div>
    );
  }

  return (
    <div className="absolute inset-0">
      <ScrollArea
        className="h-full"
      >
        <Flex
          direction="column"
          gap="3"
          mx={{
            initial: "0",
            sm: "2",
            xs: "1",
          }}
          my="1"
          className={className}
        >
          {shopList.map((s) => {
            return (
              <ShopCart
                key={s.shopSlug}
                itemList={itemList}
                shopDetail={s}
              />
            );
          })}
        </Flex>
      </ScrollArea>
    </div>
  );
};

export { CartBody };
